var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.getters.loading),expression:"$store.getters.loading"}],staticClass:"modal-mask"},[_c('div',{staticClass:"loading"},[_c('vue-loading',{attrs:{"type":"spin","color":"#0CA287","size":{ width: '100px', height: '100px' }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }